/**
 * ONE CONFIRM PER CONTACT PER SESSION — the soft guardrail's memory.
 *
 * ── Why there is no "don't ask again" checkbox ──────────────────────────────────
 *
 * The guard fires RARELY: only when a designation exists and it names somebody other than
 * the viewer. A permanent opt-out, taken in one moment of annoyance, would silently disable
 * the feature forever for the person who most needs it, with no settings screen anywhere to
 * turn it back on.
 *
 * And the complaint such a checkbox is usually added for is not "stop warning me" — it is
 * "I already told you, and you asked me again when I made the follow-up task, and a third
 * time when I sent the document." That is three confirms for one decision the realtor made
 * once. Remembering the CONTACT fixes exactly that, and nothing else: the next person a
 * colleague handles still gets the warning.
 *
 * ── Session-scoped, deliberately not persisted ─────────────────────────────────
 *
 * "I already coordinated with Dana about this lead" is true for an afternoon, not forever. A
 * module `Set` matches that lifetime, and it also means the acknowledgement cannot outlive a
 * reassignment the realtor has not seen yet.
 */

const acknowledged = new Set<string>();

export const handlerGuardAcknowledged = (contactId: string): boolean => acknowledged.has(contactId);

export const acknowledgeHandlerGuard = (contactId: string): void => {
  acknowledged.add(contactId);
};

/** Sign-out. The acknowledgements are one realtor's, not the browser's. */
export const clearHandlerGuard = (): void => acknowledged.clear();
